/* eslint-disable @typescript-eslint/no-empty-function */
import { getFileTypeFilterConfig, FilterConfig } from '../../types/header-toolbar.type';
import { FileManagerHeaderToolbarProps } from '../../utils/file-manager';
import { BaseHeaderToolbar } from '../header-toolbar/base-header-toolbar';
import { useIsMediaLibrary } from 'hooks/use-is-media-library';

export const FileManagerHeaderToolbar: React.FC<FileManagerHeaderToolbarProps> = (props) => {
  const isMediaLibrary = useIsMediaLibrary();

  const filterConfigs: FilterConfig[] = [
    getFileTypeFilterConfig({ includePhoto: isMediaLibrary }),
    {
      key: 'lastModified',
      type: 'dateRange',
      label: isMediaLibrary ? "CREATED_DATE" : "LAST_MODIFIED",
      showInMobile: true,
    },
  ];

  return (
    <BaseHeaderToolbar
      title={isMediaLibrary ? "MEDIA_LIBRARY" : "MY_FILES"}
      subtitle={isMediaLibrary ? 'LIBRARY_PAGE_DESCRIPTION' : undefined}
      viewMode={props.viewMode ?? 'grid'}
      searchQuery={props.searchQuery ?? ''}
      filters={props.filters}
      filterConfigs={filterConfigs}
      showFileUpload={!isMediaLibrary}
      showFolderCreate={!isMediaLibrary}
      onViewModeChange={props.handleViewMode}
      onSearchChange={props.onSearchChange ?? (() => { })}
      onFiltersChange={props.onFiltersChange}
      onFileUpload={props.onFileUpload}
      onFolderCreate={props.onFolderCreate}
      showTitle={props.showTitle}
    />
  );
};
